import script from "./PaymentDetails.vue?vue&type=script&setup=true&lang=ts"
export * from "./PaymentDetails.vue?vue&type=script&setup=true&lang=ts"

import "@/assets/css/loans/form.css?vue&type=style&index=0&id=170549d0&scoped=true&lang=css&external"
import "./PaymentDetails.vue?vue&type=style&index=1&id=170549d0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-170549d0"]])

export default __exports__